import React from 'react';
import { Controller } from 'react-hook-form';
import {
  TextField as GarnishTextField,
  TextFieldPassword as GarnishTextFieldPassword,
  TextFieldPhoneNumber as GarnishTextFieldPhoneNumber,
} from '../TextField';
import type { FormProps, ControlledProps } from './types';

type ComponentProps = React.ComponentProps<typeof GarnishTextField>;
type OmittedProps = ControlledProps | 'noticePalette';
type Props = FormProps & Omit<ComponentProps, OmittedProps>;

export const TextField = ({ name, control, rules, ...rest }: Props) => {
  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({
        field: { onChange, onBlur, value },
        fieldState: { invalid },
      }) => (
        <GarnishTextField
          value={value}
          invalid={invalid}
          noticePalette={invalid ? 'caution' : undefined}
          onBlur={onBlur}
          onChangeText={onChange}
          autoCorrect={false}
          autoCapitalize="none"
          {...rest}
        />
      )}
    />
  );
};

export const TextFieldPassword = ({
  name,
  control,
  rules,
  ...rest
}: Props & Readonly<{ toggleTestID?: string }>) => {
  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({
        field: { onChange, onBlur, value },
        fieldState: { invalid },
      }) => (
        <GarnishTextFieldPassword
          value={value}
          invalid={invalid}
          noticePalette={invalid ? 'caution' : undefined}
          onBlur={onBlur}
          onChangeText={onChange}
          {...rest}
        />
      )}
    />
  );
};

export const TextFieldPhoneNumber = ({
  name,
  control,
  rules,
  ...rest
}: Props) => {
  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({
        field: { onChange, onBlur, value },
        fieldState: { invalid },
      }) => (
        <GarnishTextFieldPhoneNumber
          value={value}
          invalid={invalid}
          noticePalette={invalid ? 'caution' : undefined}
          onBlur={onBlur}
          onChangeText={onChange}
          {...rest}
        />
      )}
    />
  );
};

export const TextFieldUppercase = ({
  name,
  control,
  rules,
  ...rest
}: Props) => {
  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({
        field: { onChange, onBlur, value },
        fieldState: { invalid },
      }) => (
        <GarnishTextField
          value={value?.toUpperCase()}
          invalid={invalid}
          noticePalette={invalid ? 'caution' : undefined}
          onBlur={onBlur}
          onChangeText={onChangeUppercaseText(onChange)}
          autoCorrect={false}
          autoCapitalize="none"
          {...rest}
        />
      )}
    />
  );
};

const onChangeUppercaseText =
  (onChange: (text: string) => void) => (text: string) => {
    onChange(text.toUpperCase());
  };
